import { store, defs as storeDefs } from './store';

(window as any).defs = {
  store: storeDefs,
};
export const Api = {
  store,
};
(window as any).API = Api;
